import { bindRoadCareContractToApiFormat } from '../helpers/roadCare/roadCareContractHelpers';
import { mobileApiInstance } from '../axios/mobileApiInstance';
import { APPLICATION_CONTRACT_TYPES } from '../constants';

export const createRoadCareDraftRequest = async () => {
  // handle method
};

export const updateRoadCareDraftRequest = async () => {
  // handle method
};

export const getRoadCareDraftContractByTokenRequest = async (id) => mobileApiInstance.get(`contracts/${APPLICATION_CONTRACT_TYPES.ROAD_CARE}/draft-contract/${id}`).then((response) => response.data);

export const saveCareContractInCacheRequest = async (data) => {
  const payload = bindRoadCareContractToApiFormat(data);
  return mobileApiInstance.post('cache', payload).then((response) => response.data);
};
